// extracted by mini-css-extract-plugin
export var scrollArea = "_oe-0";